









































































import { Component, Vue } from 'vue-property-decorator';
import AccountIcon from '@/components/common/AccountIcon.vue';
import CommonButton from '@/components/common/CommonButton.vue';
import AddMemberModal from '@/components/member/memberList/AddMemberModal.vue';
import BarChart from '@/components/organizationConfig/configList/Chart/BarChart.vue';

@Component({
  components: {
    BarChart,
    AccountIcon,
    CommonButton,
    AddMemberModal,
  },
})
export default class StorageConfig extends Vue {
  private plan: string = 'free';
  private storage: number = 2.0;
  private usedStorage: number = 1.0;
  private usedRatio: number = (this.usedStorage / this.storage) * 100;
  private storageList: Array<object> = [
    {
      projectId: 1,
      projectName: 'セオリー開発',
      task: '39.7MB',
      document: '2MB',
      storage: '50MB',
      subversion: '0B',
      git: '37.7MB',
      gitLFS: '0B',
      pullRequest: '68.2MB',
      total: '215MB',
      rate: '25',
    },
    {
      projectId: 2,
      projectName: 'HP開発',
      task: '9.7MB',
      document: '2MB',
      storage: '62MB',
      subversion: '0B',
      git: '7.7MB',
      gitLFS: '0B',
      pullRequest: '8.2MB',
      total: '120MB',
      rate: '20',
    },
    {
      projectId: 3,
      projectName: 'HoloLens',
      task: '39.7MB',
      document: '2MB',
      storage: '5MB',
      subversion: '0B',
      git: '37.7MB',
      gitLFS: '0B',
      pullRequest: '68.2MB',
      total: '20MB',
      rate: '20',
    },
    {
      projectId: 4,
      projectName: 'LiveMessenger',
      task: '39.7MB',
      document: '2MB',
      storage: '8MB',
      subversion: '0B',
      git: '37.7MB',
      gitLFS: '0B',
      pullRequest: '68.2MB',
      total: '200MB',
      rate: '20',
    },
  ];
}
